import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import TopSellingServices from "services/TopSellingServices";
import { notifyError, notifySuccess } from "utils/toast";

const useTopSellingSubmit = (id, carUrl, setCarUrl) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [dataInput, setDataInput] = useState([{"vehicle_type_0":"","hike_0":""}]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [existingImage, setExistingImage] = useState('');
  const [noOfNights, setNoOfNights] = useState("");
  const [noOfDays, setNoOfDays] = useState("");
  const [packagecode, setPackageCode] = useState("");
  const [packageid, setPackageId] = useState("");
  const [route, setRoute] = useState("");
  const [loading,setLoading] = useState(false);
  const handleStartDateChange = (event) => {
    const selectedStartDate = event;
    setStartDate(selectedStartDate);
    // setEndDate(selectedStartDate);
  };
  const handleVehicleCategoryChange = (e, index) => {
    const { name,value } = e.target;
    //selected value
    const onChangeVals = [...dataInput];
    onChangeVals[index][name] = value;
    setDataInput(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  

  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };
  const handleChangeInput = (e, i) => {
    if(e&&e.target){
    const { name, value } = e.target;
    const onChangeVal = [...dataInput];
    onChangeVal[i][name] = value;
    setDataInput(onChangeVal);
    }
  };
  const onSubmit = async (data) => {
    setLoading(true);
    if(!selectedCity){
      errors.state={type:'required',message:"State is required!"};
    }
    // if (!carUrl && !existingImage) {
    //   notifyError("Image is required.");
    //   errors.image={type:'required',message:"Image is required!"};
    //   setIsSubmitting(false);
    //   return;  
    // }
     const dataValues={};
     dataValues.no_of_days = noOfDays;
     dataValues.no_of_nights = noOfNights;
     dataValues.package_code = packagecode;
     dataValues.package_id = packageid;
     dataValues.route = route;
     dataValues.state = selectedCity;
     dataValues.image = carUrl || existingImage;
    try {
      setIsSubmitting(true);
      if (id) {
        const res = await TopSellingServices.updateSlider(id,dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        
        const res = await TopSellingServices.addSlider(dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getFixedItineraryPeriodicHikeData = async () => {
    try {
      const res = await TopSellingServices.getSliderById(id);
      if (res) {
        setSelectedCity(res.data.state);  
        setValue("days",res.data.no_of_days);
        setValue("nights",res.data.no_of_nights);
        setRoute(res.data.route);
        setNoOfDays(res.data.no_of_days);
        setNoOfNights(res.data.no_of_nights);
        setValue("package_code",res.data.package_code);
        setPackageCode(res.data.package_code);
        setValue("route",res.data.route);
        setExistingImage(res.data.image);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
        setValue("package_code");
        setValue("route");
        setValue("nights");
        setValue("days");
        setNoOfDays("");
        setNoOfNights("");
        setSelectedCity("");
        setCarUrl("");
        setRoute("");
        setPackageCode("");
        clearErrors(); 
  
      return;
    }
      
    if (id) {
      getFixedItineraryPeriodicHikeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    handleCityChange,
    selectedCity,
    trigger,
    errors,
    isSubmitting,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    setStartDate,
    startDate,
    handleStartDateChange,
    setEndDate,
    endDate,
    noOfNights,
    setNoOfDays,
    noOfDays,
    setNoOfNights,
    existingImage,
    setExistingImage,
    setPackageCode, packagecode,
    route, setRoute,setSelectedCity,
    setPackageId,packageid,loading,setLoading,
  };
};

export default useTopSellingSubmit;
